import request from '@/units/request';
import { baseUrl } from '@/units/config';


const getDomain = () => {
  let href = window.location.protocol + '//';
  href += window.location.host + '/';
  if (window.location.hash !== '') {
    href += '#/';
  }
  return href;
};

export default {
  // 获取租户id
  getTenantId: () => {
    return request({
      url: '/api/common/getTenantId',
      params: {
        platform: 'H5',
        domain: getDomain(),
      },
      custom: {
        showLoading: false,
      },
    });
  },
  getTenantList: (params = {}) => {
    return request({
      url: '/api/common/getTenantList',
      params,
      custom: {
        showLoading: false,
      },
    });
  },
  getSlideList: (params = {}) => {
    return request({
      url: '/api/common/slideList',
      params,
      custom: {
        showLoading: false,
      },
    });
  },
  getOssConfig: (params = {}) =>
    request({
      url: '/api/common/getOssConfig',
      params,
      custom: {
        showError: false,
        showLoading: false,
      },
    }),
  // 系统初始化
  init: (templateId) =>
    request({
      url: 'index/init',
      params: {
        templateId,
      },
      custom: {
        showError: false,
        showLoading: false,
      },
    }),
  // 同步客户端页面到后端
  pageSync: (pages) =>
    request({
      url: 'index/pageSync',
      method: 'POST',
      data: {
        pages,
      },
      custom: {
        showError: false,
        showLoading: false,
      },
    }),
  // 发送短信
  sendSms: (data) =>
    request({
      url: '/api/sms/send',
      method: 'POST',
      data,
      custom: {
        showSuccess: true,
        loadingMsg: '发送中',
      },
    }),
  // 意见反馈
  feedback: (data) =>
    request({
      url: 'index/feedback',
      method: 'POST',
      data,
    }),
  // 自定义页面
  page: (id) =>
    request({
      url: 'index/page',
      method: 'GET',
      params: {
        id: id,
      },
    }),
  // 积分商城
  scoreShop: {
    list: (params) =>
      request({
        url: 'app.score_shop/index',
        method: 'GET',
        params,
      }),
    ids: (params = {}) =>
      request({
        url: 'app.score_shop/ids',
        method: 'GET',
        params,
      }),
    detail: (id) =>
      request({
        url: 'app.score_shop/detail',
        method: 'GET',
        params: {
          id: id,
        },
      }),
  },
  // 小程序直播
  mplive: {
    getMpLink: () =>
      request({
        url: 'app.mplive/getMpLink',
        method: 'GET',
      }),
    getRoomList: (ids) =>
      request({
        url: 'app.mplive/getRoomList',
        method: 'GET',
        params: {
          ids: ids.join(','),
        },
      }),
  },
  // 上传
  upload: (data) => request({
    url: '/api/ajax/upload',
    method: 'POST',
    data
  }),
};



// WEBPACK FOOTER //
// ./src/api/app.js